import { render, staticRenderFns } from "./traffic.vue?vue&type=template&id=aa6fe5d6&scoped=true&"
import script from "./traffic.vue?vue&type=script&lang=js&"
export * from "./traffic.vue?vue&type=script&lang=js&"
import style0 from "./traffic.vue?vue&type=style&index=0&id=aa6fe5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6fe5d6",
  null
  
)

export default component.exports